"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeValidator = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const errors_1 = require("../../../interface/errors");
var TradeValidator;
(function (TradeValidator) {
    function formatValue(decimal, symbolInfo, investSide, rounding) {
        var _a, _b;
        const locale = (0, trade_utils_lib_1.getTradeDependencyInstance)().getLocale();
        if (investSide === interface_1.InvestSymbolSide.base) {
            const val = trade_utils_lib_1.NumberFormatter.format(decimal.toDP((_a = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount) !== null && _a !== void 0 ? _a : 0, rounding), {
                locale,
                precision: "default",
            });
            return val + ((symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay) ? ` ${symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay}` : "");
        }
        const val = trade_utils_lib_1.NumberFormatter.format(decimal.toDP((_b = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _b !== void 0 ? _b : 0, rounding), {
            locale,
            precision: "default",
        });
        return val + ((symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay) ? ` ${symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay}` : "");
    }
    TradeValidator.formatValue = formatValue;
    /** 获取市价单投quote时的最小跟最大名义价值 */
    function getMarketSpendingNotionRange(symbol) {
        var _a, _b, _c, _d;
        return [new trade_utils_lib_1.SafeDecimal((_b = (_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.spending.min) !== null && _b !== void 0 ? _b : 0), new trade_utils_lib_1.SafeDecimal((_d = (_c = symbol.limit) === null || _c === void 0 ? void 0 : _c.spending.max) !== null && _d !== void 0 ? _d : Number.MAX_VALUE)];
    }
    TradeValidator.getMarketSpendingNotionRange = getMarketSpendingNotionRange;
    /** 校验市价单投入 quote 是否合法 orderType MARKET_AMT */
    function getValidateMarketSpending({ value, symbol, reduceOnly = false, verifyMax = true, investSide, tradePrice, leverage, }) {
        const [quoteMin, quoteMax] = getMarketSpendingNotionRange(symbol);
        const isBase = investSide === interface_1.InvestSymbolSide.base;
        const getErrorTipsVal = (limit) => {
            if (isBase) {
                return limit.div(tradePrice);
            }
            if (investSide === interface_1.InvestSymbolSide.cost) {
                return limit.div(leverage);
            }
            return limit;
        };
        if (!reduceOnly && value.lt(quoteMin)) {
            const errorTipsValue = getErrorTipsVal(quoteMin);
            return {
                error: (0, errors_1.cloneError)(isBase ? errors_1.TRADE_QTY_LOW_THAN_MIN : errors_1.TRADE_QUOTE_LOW_THAN_MIN, {
                    min: formatValue(errorTipsValue, symbol, investSide, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
                }),
                errorType: "tooSmall",
                val: errorTipsValue,
            };
        }
        if (verifyMax && value.gt(quoteMax)) {
            const errorTipsValue = getErrorTipsVal(quoteMax);
            return {
                error: (0, errors_1.cloneError)(isBase ? errors_1.TRADE_QTY_HIGH_THAN_MAX_BY_BASE : errors_1.TRADE_QTY_HIGH_THAN_MAX_BY_QUOTE, {
                    max: formatValue(errorTipsValue, symbol, investSide, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
                }),
                errorType: "tooLarge",
                val: errorTipsValue,
            };
        }
        return undefined;
    }
    TradeValidator.getValidateMarketSpending = getValidateMarketSpending;
    /** 获取市价单投quote时的最大名义价值 */
    function getMaxMarketSpending(symbolInfo) {
        var _a, _b;
        return new trade_utils_lib_1.SafeDecimal((_b = (_a = symbolInfo.limit) === null || _a === void 0 ? void 0 : _a.spending.max) !== null && _b !== void 0 ? _b : Number.MAX_VALUE);
    }
    TradeValidator.getMaxMarketSpending = getMaxMarketSpending;
    /** 获取市价单投base时的最大名义价值 */
    function getMaxMarketQty(symbolInfo) {
        var _a;
        const { max: maxQty = Number.MAX_SAFE_INTEGER } = ((_a = symbolInfo.limit) === null || _a === void 0 ? void 0 : _a.dumping) || {};
        return new trade_utils_lib_1.SafeDecimal(maxQty);
    }
    TradeValidator.getMaxMarketQty = getMaxMarketQty;
    /** 获取限价单投base时的最大名义价值 */
    function getMaxLimitQty(symbolInfo) {
        var _a;
        const { max: maxQty = Number.MAX_SAFE_INTEGER } = ((_a = symbolInfo.limit) === null || _a === void 0 ? void 0 : _a.amount) || {};
        return new trade_utils_lib_1.SafeDecimal(maxQty);
    }
    TradeValidator.getMaxLimitQty = getMaxLimitQty;
    /** 获取市价单投base时的最小跟最大名义价值 */
    function getMarketQtyRange(symbolInfo, price, reduceOnly = false) {
        var _a, _b, _c;
        const { min: minQty = 0, max: maxQty = Number.MAX_SAFE_INTEGER } = ((_a = symbolInfo.limit) === null || _a === void 0 ? void 0 : _a.dumping) || {};
        let min = new trade_utils_lib_1.SafeDecimal(minQty);
        const max = new trade_utils_lib_1.SafeDecimal(maxQty);
        if (reduceOnly) {
            return [new trade_utils_lib_1.SafeDecimal(minQty), max];
        }
        // 判断名义价值
        const minNotion = (_c = (_b = symbolInfo.limit) === null || _b === void 0 ? void 0 : _b.spending.min) !== null && _c !== void 0 ? _c : 0;
        min = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(minNotion).div(new trade_utils_lib_1.SafeDecimal(price)), min);
        return [min, max];
    }
    TradeValidator.getMarketQtyRange = getMarketQtyRange;
    /** 获取校验市价单投入 base 的错误信息 */
    function getValidateMarketQty({ value, symbol, reduceOnly = false, verifyMax = true, investSide, tradePrice, leverage, }) {
        const [min, max] = getMarketQtyRange(symbol, tradePrice.toString(), reduceOnly);
        const isBase = investSide === interface_1.InvestSymbolSide.base;
        if (value.lt(min)) {
            const val = (() => {
                if (investSide === interface_1.InvestSymbolSide.cost) {
                    return min.mul(tradePrice).mul(1.0005).div(leverage);
                }
                if (investSide === interface_1.InvestSymbolSide.quote) {
                    return min.mul(tradePrice).mul(1.0005);
                }
                return min;
            })();
            return {
                error: (0, errors_1.cloneError)(isBase ? errors_1.TRADE_QTY_LOW_THAN_MIN : errors_1.TRADE_QTY_LOW_THAN_MIN_BY_QUOTE, {
                    min: formatValue(val, symbol, investSide, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
                }),
                errorType: "tooSmall",
                val,
            };
        }
        if (verifyMax && value.gt(max)) {
            const val = (() => {
                if (investSide === interface_1.InvestSymbolSide.cost) {
                    return max.mul(tradePrice).div(leverage);
                }
                if (investSide === interface_1.InvestSymbolSide.quote) {
                    return max.mul(tradePrice);
                }
                return max;
            })();
            return {
                error: (0, errors_1.cloneError)(isBase ? errors_1.TRADE_QTY_HIGH_THAN_MAX_BY_BASE : errors_1.TRADE_QTY_HIGH_THAN_MAX_BY_QUOTE, {
                    max: formatValue(val, symbol, investSide, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
                }),
                errorType: "tooLarge",
                val,
            };
        }
        return undefined;
    }
    TradeValidator.getValidateMarketQty = getValidateMarketQty;
    /** 获取限价投入base的区间 */
    function getLimitQtyRange(symbolInfo, price, reduceOnly = false) {
        var _a, _b, _c;
        const { min: minQty = 0, max: maxQty = Number.MAX_VALUE } = ((_a = symbolInfo.limit) === null || _a === void 0 ? void 0 : _a.amount) || {};
        let min = new trade_utils_lib_1.SafeDecimal(minQty);
        const max = new trade_utils_lib_1.SafeDecimal(maxQty);
        if (reduceOnly) {
            return [min, max];
        }
        // 判断名义价值
        if (!new trade_utils_lib_1.SafeDecimal(price).eq(0)) {
            const minNotion = (_c = (_b = symbolInfo.limit) === null || _b === void 0 ? void 0 : _b.spending.min) !== null && _c !== void 0 ? _c : 0;
            min = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(minNotion).div(new trade_utils_lib_1.SafeDecimal(price)), min);
        }
        return [min, max];
    }
    TradeValidator.getLimitQtyRange = getLimitQtyRange;
    /** 校验限价单投入 base 是否合法 */
    function validateLimitQty(amountD, symbolInfo, price, reduceOnly = false, verifyMax = true) {
        const [min, max] = getLimitQtyRange(symbolInfo, price, reduceOnly);
        if (amountD.lt(min)) {
            return (0, errors_1.cloneError)(errors_1.TRADE_QTY_LOW_THAN_MIN, {
                min: formatValue(min, symbolInfo, interface_1.InvestSymbolSide.base, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
            });
        }
        if (verifyMax && amountD.gt(max)) {
            return (0, errors_1.cloneError)(errors_1.TRADE_QTY_HIGH_THAN_MAX_BY_BASE, {
                max: formatValue(max, symbolInfo, interface_1.InvestSymbolSide.base, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
            });
        }
        return undefined;
    }
    TradeValidator.validateLimitQty = validateLimitQty;
    /** 校验限价单投入 quote 是否合法 */
    function validateLimitSpending({ spending, symbolInfo, price, reduceOnly = false, verifyMax = true, investSide, leverage, }) {
        const [baseMin, baseMax] = getLimitQtyRange(symbolInfo, price, reduceOnly);
        /** 投资额转换为 base 的值 */
        const baseAmount = spending.div(new trade_utils_lib_1.SafeDecimal(price));
        const getQuoteLimitByBase = (baseLimit) => {
            const quoteLimit = baseLimit.mul(new trade_utils_lib_1.SafeDecimal(price));
            return investSide === interface_1.InvestSymbolSide.cost ? quoteLimit.div(leverage) : quoteLimit;
        };
        if (baseAmount.lt(baseMin)) {
            const minQuote = getQuoteLimitByBase(baseMin);
            return (0, errors_1.cloneError)(errors_1.TRADE_QUOTE_LOW_THAN_MIN, {
                min: formatValue(minQuote, symbolInfo, interface_1.InvestSymbolSide.quote, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
            });
        }
        if (verifyMax && baseAmount.gt(baseMax)) {
            const maxQuote = getQuoteLimitByBase(baseMax);
            return (0, errors_1.cloneError)(errors_1.TRADE_QTY_HIGH_THAN_MAX_BY_QUOTE, {
                max: formatValue(maxQuote, symbolInfo, interface_1.InvestSymbolSide.quote, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
            });
        }
        return undefined;
    }
    TradeValidator.validateLimitSpending = validateLimitSpending;
    function getMaxImpactMarket(symbolInfo) {
        var _a, _b;
        return new trade_utils_lib_1.SafeDecimal((_b = (_a = symbolInfo.originData) === null || _a === void 0 ? void 0 : _a.max_impact_market) !== null && _b !== void 0 ? _b : 0);
    }
    TradeValidator.getMaxImpactMarket = getMaxImpactMarket;
    /** 获取市价的成交均价 */
    function getAvgMarketPrice(symbolInfo, markPrice, orderSide, reduceOnly = false) {
        var _a;
        const maxImpactMarket = getMaxImpactMarket(symbolInfo);
        const markPriceD = new trade_utils_lib_1.SafeDecimal(markPrice);
        const priceD = (() => {
            if (reduceOnly) {
                return markPriceD;
            }
            if (orderSide === interface_1.CustomOrderSide.BUY) {
                // 放大价格
                return markPriceD.div(new trade_utils_lib_1.SafeDecimal(1).sub(maxImpactMarket));
            }
            // 减小价格
            return markPriceD.mul(new trade_utils_lib_1.SafeDecimal(1).sub(maxImpactMarket));
        })();
        return priceD.toDP((_a = symbolInfo.precision) !== null && _a !== void 0 ? _a : 0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
    }
    TradeValidator.getAvgMarketPrice = getAvgMarketPrice;
})(TradeValidator = exports.TradeValidator || (exports.TradeValidator = {}));
